/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/pages/auth'
import {Languages} from './Languages'
import {changeTextCamal, toAbsoluteUrl} from '../../../helpers'
import {ChangePassword} from '../../../../app/pages/NewUser/ChangePassword'
import {cU} from '@fullcalendar/core/internal-common'

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  const [openModal, setOpenModal] = useState(false)
  const [openModal1, setOpenModal1] = useState(false)
  const [editId, seteditId] = useState<string | null | undefined>(null)
  const [user, setUser] = useState('currentUser')

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
      data-popper-placement='bottom-start'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <div className='card border p-3 ls-3'>
              {currentUser ? currentUser?.firstName.charAt(0).toUpperCase() : ''}
              {currentUser ? currentUser?.lastName.charAt(0).toUpperCase() : ''}
            </div>
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bold d-flex align-items-center fs-5'>
              {currentUser ? changeTextCamal(currentUser.firstName) : ''}{' '}
              {currentUser ? changeTextCamal(currentUser.lastName) : ''}
            </div>
          </div>
        </div>
      </div>
      <div className='menu-item px-5'>
        <a
          onClick={() => {
            setOpenModal1(true)
            seteditId(currentUser?.email)
            setUser('currentUser')
            //  const searchInput = $('div.dataTables_filter input')
            //  searchInput.val(obj.email)
            //  searchInput.trigger('keyup')
          }}
          className='menu-link px-5'
        >
          Change Password
        </a>
      </div>
      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
      <ChangePassword
        openModel1={openModal1}
        setOpenModel1={setOpenModal1}
        email_id={editId}
        setEditId={seteditId}
        userType='currentUser'
      />
    </div>
  )
}

export {HeaderUserMenu}
